import { render } from "./TxMap.vue?vue&type=template&id=080c617d&scoped=true"
import script from "./TxMap.vue?vue&type=script&lang=js"
export * from "./TxMap.vue?vue&type=script&lang=js"

import "./TxMap.vue?vue&type=style&index=0&id=080c617d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-080c617d"]])

export default __exports__